module.exports = __webpack_public_path__ + "fonts/IRANYekanWebBold.c2639df.woff";